import { CustomerLogoutResponse } from '@porterin/booking-flow/src/auth/domain/api-models/CustomerLogoutApiModel';
import { CustomerLogout } from '@porterin/booking-flow/src/auth/domain/entities/CustomerLogout';

const toCustomerLogoutEntity = (
  apiModel: CustomerLogoutResponse,
): CustomerLogout => {
  return {
    logoutSuccess: apiModel.logout_success,
  };
};

export { toCustomerLogoutEntity };
